import React from 'react'
import { useOutletContext } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { type DateRange } from '@smartasn/wlb-utils-components'
import DateRangeModal from '../../../../../components/modal/DateRangeModal'
import TimeChartCard, {
  TimeKind,
  RangeType,
  getDateRange,
  type EarningsData,
} from '../../../../../components/contributor/dashboard/TimeChartCard'
import { INSTRUCTOR_CONTEXT } from '../../../../../utils/contributor-helpers'
import { GET_CONTRIBUTOR_BOOK_EARNING_BREAKDOWN } from '../../../../../graphql/queries'
import { BookPageContext } from '../ContributorBookDetailPageLayout'

const BookEarningsCard = () => {
  const { isbn } = useOutletContext<BookPageContext>()

  const [rangeType, setRangeType] = React.useState(RangeType.WEEK)
  const [customRange, setCustomRange] = React.useState<DateRange | undefined>()
  const [openPicker, setOpenPicker] = React.useState(false)

  const range = React.useMemo(() => {
    return getDateRange(rangeType, customRange)
  }, [rangeType, customRange])

  const { data } = useQuery(GET_CONTRIBUTOR_BOOK_EARNING_BREAKDOWN, {
    skip: isbn === undefined,
    fetchPolicy: 'network-only',
    variables: {
      isbn,
      timeType: range.timeType,
      startDate: range.startDate,
      endDate: range.endDate,
    },
    context: INSTRUCTOR_CONTEXT,
  })

  const earningsData = React.useMemo((): EarningsData | null => {
    if (!data) {
      return null
    }

    return {
      earnings: data.getEarningByTimeBookDetail.earning_book || [],
    }
  }, [data])

  const handleRangeChange = (next: RangeType) => {
    if (next === RangeType.CUSTOM) {
      setOpenPicker(true)
    } else {
      setRangeType(next)
    }
  }

  const handlePickerClose = () => {
    setOpenPicker(false)
  }

  const handlePickerSubmit = (range: DateRange) => {
    setRangeType(RangeType.CUSTOM)
    setCustomRange(range)
    setOpenPicker(false)
  }

  return (
    <>
      <TimeChartCard
        kind={TimeKind.EARNINGS}
        rangeType={rangeType}
        ranges={range}
        data={earningsData}
        onTypeChange={handleRangeChange}
        onReportClick={() => { }}
      />

      <DateRangeModal
        open={openPicker}
        initialRange={customRange}
        onClose={handlePickerClose}
        onSubmit={handlePickerSubmit}
      />
    </>
  )
}

export default BookEarningsCard
